import React from 'react';
import { Row, Divider, Switch, Col, Spin } from 'antd';

import { CardLayout, getIntFromString, ReactMarkdown } from '../../look';
import { IMG } from '../../../config';

import ROUTE from '../route';
import ToolAssign from '../containers/ToolAssign';

import AddComponent from './AddComponent';
import CommitmentSection from './CommitmentSection';
import TextFormSectionComponent from './TextFormSectionComponent';

const ToolDetailView = props => {
  const {
    loading,
    getToolByIdAdmin,
    editTool,
    onCommitmentDelete,
    actionLoading,
    setActionLoading,
    onTextSectionDelete,
    onFormSectionDelete,
    subscribeToMore
  } = props;
  const [assign, setAssign] = React.useState(false);

  const handleEditTool = async (e, field) => {
    setActionLoading(true);
    let data = {};
    if (field === 'public') data = { public: e };
    if (field === 'status') data = { status: e };
    if (field === 'commitment')
      data = {
        commitment: [e, ...(getToolByIdAdmin.commitment?.edges?.map(({ node }) => getIntFromString(node?.id)) || [])]
      };
    if (field === 'textsection')
      data = {
        textsection: [e, ...(getToolByIdAdmin.textsection?.edges?.map(({ node }) => getIntFromString(node?.id)) || [])]
      };
    if (field === 'formsection')
      data = {
        formsection: e
      };
    try {
      const response = await editTool({
        id: Number(getIntFromString(getToolByIdAdmin.id)),
        name: getToolByIdAdmin.name,
        ...data
      });
      setActionLoading(false);
      return response;
    } catch (e) {
      setActionLoading(false);
      throw new Error(e.message);
    }
  };

  // console.log(getToolByIdAdmin?.formsection);
  return (
    <CardLayout
      active={ROUTE.survey}
      title={[
        {
          name: getToolByIdAdmin?.title || ''
          // link: `${ROUTE.surveyDetailLink}${getToolByIdAdmin && getIntFromString(getToolByIdAdmin.id)}`
        }
      ]}
      showTitle={false}
      editLink={ROUTE.editToolLink}
      addLink={ROUTE.addTool}
      backLink={ROUTE.tool}
      // onFiltersRemove={onFiltersRemove}
      showBack={false}
      table={false}
      rowKey={getToolByIdAdmin && getToolByIdAdmin.id}
    >
      <Row>
        <Col span={24}>
          <Spin spinning={loading || actionLoading} size="large">
            <div style={{ minHeight: '70vh' }}>
              {getToolByIdAdmin && (
                <>
                  <Row gutter={[24, 24]}>
                    <Col lg={8} md={6} xs={24}>
                      <Row gutter={[24, 24]} justify="center">
                        <Col align="center">
                          <img alt={getToolByIdAdmin.title} src={getToolByIdAdmin.thumbnailImage || IMG} width="100%" />
                        </Col>
                      </Row>
                      <br />

                      <Row justify="space-between" align="bottom" gutter={[24, 24]}>
                        <Col>
                          Public
                          <br />
                          <Switch
                            checked={getToolByIdAdmin.public}
                            size="small"
                            onClick={e => handleEditTool(e, 'public')}
                          />
                        </Col>

                        <Col>
                          Published
                          <br />
                          <Switch
                            checked={getToolByIdAdmin.status}
                            size="small"
                            onClick={e => handleEditTool(e, 'status')}
                          />
                        </Col>
                      </Row>
                    </Col>
                    <Col span={1}>
                      <Divider type="vertical" style={{ height: '100%' }} />
                    </Col>

                    <Col lg={15} md={17} xs={24}>
                      <Row>
                        <ToolAssign getToolByIdAdmin={getToolByIdAdmin} assign={assign} setAssign={setAssign} />
                      </Row>
                      <br />

                      <Row
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'baseline'
                        }}
                      >
                        <h3 style={{ marginBottom: 0, fontWeight: 'normal' }}>Description</h3>
                      </Row>
                      <div
                        style={{
                          border: '1px solid rgba(202, 202, 202, 0.25)',
                          margin: '7px',
                          padding: '15px',
                          height: '80%',
                          borderRadius: '2px'
                        }}
                      >
                        <ReactMarkdown>{getToolByIdAdmin.description}</ReactMarkdown>
                      </div>
                    </Col>
                  </Row>
                  <br />
                  <br />
                  <br />

                  <CommitmentSection
                    commitment={getToolByIdAdmin?.commitment}
                    handleEditTool={handleEditTool}
                    setActionLoading={setActionLoading}
                    onCommitmentDelete={onCommitmentDelete}
                    subscribeToMore={subscribeToMore}
                  />

                  <TextFormSectionComponent
                    formsection={getToolByIdAdmin?.formsection}
                    textsection={getToolByIdAdmin?.textsection}
                    onTextSectionDelete={onTextSectionDelete}
                    onFormSectionDelete={onFormSectionDelete}
                    setActionLoading={setActionLoading}
                    subscribeToMore={subscribeToMore}
                    handleEditTool={handleEditTool}
                  />
                </>
              )}
            </div>
          </Spin>
        </Col>
      </Row>
    </CardLayout>
  );
};

export default ToolDetailView;
